import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
        name: 'currencySymbol'
})
export class CurrencySymbolFirstPipe implements PipeTransform {
    transform(value: number, currency: string = 'XAF', locale: string = 'fr-FR'): string {
        if (value == null || isNaN(value)) return `${currency} 0`;

        const absValue = Math.abs(value).toLocaleString(locale, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        });

        const sign = value < 0 ? '-' : '';

        return `${currency} ${sign}${absValue}`;
    }
}
